import React from 'react';
import MultipleSelectDropDown, { OptionType } from './MultipleSelectDropDown';
import featureFlags, { FrontendFeature } from '../../../featureFlags';
import { useSelector } from 'react-redux';
import { State } from '../../../dux/@types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

interface ColumnSelectDropdownProps {
  selectedColumns: string[];
  setSelectedColumns: (a: any) => void;
  columnOptions: OptionType<string>[];
}

export const ColumnSelectDropdown: React.FC<ColumnSelectDropdownProps> = (props) => {
  const CONFIG_TITLE = 'Columns';
  const { selectedColumns, setSelectedColumns, columnOptions } = props;
  const orgUser = useSelector((state: State) => state.account.organizationUser);

  const isCustomFieldEnabled = featureFlags.isFeatureEnabledForUser(
    FrontendFeature.CustomFields,
    orgUser,
  );

  if (!isCustomFieldEnabled) return <></>;

  return (
    <div className="culumn-config-modal mr-2">
      <MultipleSelectDropDown
        currentSelectedValues={selectedColumns}
        floatSelectedToTop
        height="350px"
        hideCount={true}
        icon={<FontAwesomeIcon className="dropdown-icon" icon={faPencil} />}
        onChange={(values) => {
          setSelectedColumns([...values]);
        }}
        options={columnOptions}
        search
        title={CONFIG_TITLE}
      />
    </div>
  );
};

export default ColumnSelectDropdown;
